module.exports = __webpack_public_path__ + "img/pr-24.614f1172.png";